var subtractCostFromBalance = function (balance, cost) {
    var balanceAmount = Number(balance.amount * 100);
    var balanceCurrency = cost.currency.toLowerCase();
    var costAmount = Number(cost.amount * 100);
    var amount = Math.trunc(balanceAmount - costAmount) / 100;
    return {
        amount: amount,
        currency: balanceCurrency
    };
};
export default subtractCostFromBalance;
